module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-equipo contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mi equipo")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "body"
  }, [(_vm.isShowingJefeDirecto) ? _c('div', {
    staticClass: "message is-info"
  }, [_vm._m(0)]) : _vm._e(), (_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Fecha Ingreso")]), (_vm.isShowingJefeDirecto) ? _c('th', [_vm._v("Jefe directo")]) : _vm._e(), _c('th', [_vm._v("Fecha de fin de contrato")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.equipo), function(o, index) {
    return _c('tr', {
      key: index + '-desktop',
      staticClass: "row-table",
      class: {
        directo: o.directo, 'row-info': o.esDeDelegacion
      }
    }, [_c('td', [_c('span', {
      staticClass: "name hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dni
      }
    }, [_vm._v(_vm._s(o.nombre))]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v(" (" + _vm._s(o.cargo) + ")")])]), _c('td', [_c('div', {
      staticClass: "wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.fechaIngreso))]), (!o.contratoIndeterminado) ? [(o.diasParaIndeterminado < 0) ? [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Ya deberia ser indeterminado")])] : [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Indeterminado en: ")]), _c('span', [_vm._v(_vm._s(o.diasParaIndeterminado + ' días'))])]] : _vm._e()], 2)]), (_vm.isShowingJefeDirecto) ? _c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_vm._v(_vm._s(o.nombreJefe))])]) : _vm._e(), _c('td', {
      staticClass: "contrato"
    }, [(o.contratoIndeterminado === 1) ? _c('div', [_c('span', [_vm._v("Contrato indeterminado")])]) : _vm._e(), (o.contratoIndeterminado === -1) ? _c('div', [_c('span', [_vm._v("Se indico que no se debe renovar")])]) : _vm._e(), (o.contratoIndeterminado === 0) ? _c('div', [(o.fechaFinContrato) ? _c('div', [_c('span', [_vm._v(_vm._s(o.fechaFinContrato))]), _c('br'), _c('span', {
      staticClass: "email"
    }, [_vm._v("Faltan "), _c('strong', [_vm._v(_vm._s(o.diasVencimientoContrato) + " ")]), _vm._v("días para el vencimiento del contrato")]), ((o.directo || o.codigoJefe === +_vm.codigoLogueadoJefe) && o.diasVencimientoContrato <= 15 && _vm.mostrarRenovacion) ? _c('pedir-una-renovacion', {
      attrs: {
        "codigo": o.codigo,
        "nombre": o.nombre,
        "idSolicitud": o.idSolicitudRenovacion,
        "descripcionEstado": o.solicitudEstadoDescripcion
      },
      on: {
        "closeRefresh": _vm.refreshRenovar
      }
    }) : _vm._e()], 1) : _c('span', [_vm._v("No se ha enviado la información desde planillas")])]) : _vm._e()])])
  }), 0)], 1)]) : _vm._e(), (!_vm.isLoading) ? _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.equipo), function(o, index) {
    return _c('div', {
      key: index + '-mobile',
      staticClass: "box has-text-left bg-white"
    }, [_c('div', {
      staticClass: "mt-10 hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dni
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Cargo: ")]), _c('span', [_vm._v(_vm._s(o.cargo))])]), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Fecha de Ingreso: ")]), _c('span', [_vm._v(_vm._s(o.fechaIngreso))])]), (!o.contratoIndeterminado) ? _c('div', [(o.diasParaIndeterminado < 0) ? [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Ya deberia ser indeterminado")])] : [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Indeterminado en: ")]), _c('span', [_vm._v(_vm._s(o.diasParaIndeterminado + ' días'))])]], 2) : _vm._e(), _c('div', [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Fin de Contrato: ")]), (o.contratoIndeterminado === 1) ? _c('span', [_vm._v("Contrato indeterminado")]) : _vm._e(), (o.contratoIndeterminado === -1) ? _c('span', [_vm._v("Se indico que no se debe renovar")]) : _vm._e(), (o.contratoIndeterminado === 0) ? [(o.fechaFinContrato) ? [_c('span', [_vm._v(_vm._s(o.fechaFinContrato))]), _c('br'), _c('span', {
      staticClass: "text-small"
    }, [_vm._v("Faltan "), _c('strong', [_vm._v(_vm._s(o.diasVencimientoContrato) + " ")]), _vm._v("días para el vencimiento del contrato")])] : _c('span', [_vm._v("No se ha enviado la información desde planillas")])] : _vm._e()], 2), (_vm.codigoLogueadoJefe !== (o.codigoJefe + '')) ? _c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Jefe: ' + o.dniJefe
      }
    }, [_c('span', {
      staticClass: "text-small"
    }, [_vm._v("Jefe: ")]), _c('span', [_vm._v(_vm._s(o.nombreJefe))])]) : _vm._e(), (o.contratoIndeterminado === 0) ? _c('div', [(o.fechaFinContrato) ? [(o.directo && o.diasVencimientoContrato <= 15 && _vm.mostrarRenovacion) ? _c('pedir-una-renovacion', {
      attrs: {
        "codigo": o.codigo,
        "nombre": o.nombre,
        "idSolicitud": o.idSolicitudRenovacion,
        "descripcionEstado": o.solicitudEstadoDescripcion
      },
      on: {
        "closeRefresh": _vm.refreshRenovar
      }
    }) : _vm._e()] : _vm._e()], 2) : _vm._e()])
  }), 0) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-body"
  }, [_c('strong', [_vm._v("*")]), _c('span', [_vm._v("Los empleados con texto resaltado son empleados directos, es decir, es tu responsabilidad solicitar la renovación")]), _c('span', [_vm._v("del contrato de ellos.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e5fcf6a","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Contratos_Lista_Equipo.vue
// module id = 898
// module chunks = 0